import React, { useContext, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import { Acl } from 'modules/common/components/Acl';
import { getJson } from 'session';
import emptyStateImage from 'assets/img/icn-empty-state.svg';
import PropertyLocation from '../components/PropertyLocation'
import Information from '../components/Information';
import * as actions from '../action';
import * as c from '../constant';
// import AdditionalCostsContainer from '../components/additional-costs/container/AdditionalCostsContainer';
import PropertyAppraisalContainer from '../components/property-appraisal/container/PropertyAppraisalContainer';
import FloorAreaContainer from '../components/floor-area/containers/FloorAreaContainer';
import PropertyAssessmentContainer from '../components/property-assessment/container/PropertyAssessmentContainer';
import SupersededAssessmentContainer from '../components/superseded-assessment/container/SupersededAssessmentContainer';
import StructuralMaterialsContainer from '../components/structural-materials/container/StructuralMaterialsContainer';
import BuildingTransactionsContainer from '../components/transactions/container/BuildingTransactionsContainer';
import HistoryContainer from '../components/history/container/HistoryContainer';
import AdditionalItemsContainer from '../components/additional-items/container/AdditionalItemsContainer';
import PaymentHistory from '../components/payment-history/container/PaymentHistory';
import NewDeclarationModal from '../modals/transaction/components/NewDeclarationModal';
import EditBuildingModal from '../modals/EditBuildingModal';
import TransactionModal from '../modals/transaction/TransactionModal';

function BuildingApplicationContent({
  applicationId,
  showData,
  applicationInfo,
  permissions,
  handleLogsModal,
  handleCancel,
  handlePost,
  handleRevert,
  ordinanceRevisionId,
}) {

  const setModal = useContext(ModalContext);

  const [activeTab, setActiveTab] = useState(1);

  const [formData, setFormData] = useState({
    scroll: 0,
  });
  const scrollref = React.createRef();

  useEffect(() => {
    if (_.isEmpty(applicationId)) return;
    showData(applicationId);
  }, []);

  useEffect(() => {
    if (_.isEmpty(applicationId)) return;
    showData(applicationId);
  }, [applicationId]);

  const handleEdit = (data) => (e) => {
    e.preventDefault();

    switch (_.get(data, 'attributes.rptax_transaction_code_id')) {
      case 1:
        return setModal({
          isOpen: true,
          content: (
            <NewDeclarationModal
              modalType="EDIT"
              applicationId={applicationId}
              transactionCode={_.get(data, 'attributes.rptax_transaction_code_id')}
              ordinanceRevisionId={+ordinanceRevisionId}
            />),
          title: 'Update New Declaration (Discovery) Transaction',
          modalSize: 'modal-xl',
        });
      case 2:
        return setModal({
          isOpen: true,
          content: (
            <EditBuildingModal
              modalType="EDIT"
              applicationId={applicationId}
              transactionCode={_.get(data, 'attributes.rptax_transaction_code_id')}
            />),
          title: 'Update Subdivision',
          modalSize: 'modal-xl',
        });
      case 3:
        return setModal({
          isOpen: true,
          content: (
            <EditBuildingModal
              modalType="EDIT"
              applicationId={applicationId}
              transactionCode={_.get(data, 'attributes.rptax_transaction_code_id')}
            />),
          title: 'Update Consolidation',
          modalSize: 'modal-xl',
        });
      case 4:
        return setModal({
          isOpen: true,
          content: (
            <EditBuildingModal
              modalType="EDIT"
              applicationId={applicationId}
              transactionCode={_.get(data, 'attributes.rptax_transaction_code_id')}
            />),
          title: 'Update Dispute',
          modalSize: 'modal-xl',
        });
      case 5:
        return setModal({
          isOpen: true,
          content: (
            <EditBuildingModal
              modalType="EDIT"
              applicationId={applicationId}
              transactionCode={_.get(data, 'attributes.rptax_transaction_code_id')}
            />),
          title: 'Update Transfer Ownernship',
          modalSize: 'modal-xl',
        });
      case 10:
        return setModal({
          isOpen: true,
          content: (
            <EditBuildingModal
              modalType="EDIT"
              applicationId={applicationId}
              transactionCode={_.get(data, 'attributes.rptax_transaction_code_id')}
            />),
          title: 'Update Physical Change',
          modalSize: 'modal-xl',
        });
      case 12:
        return setModal({
          isOpen: true,
          content: (
            <EditBuildingModal
              modalType="EDIT"
              applicationId={applicationId}
              transactionCode={_.get(data, 'attributes.rptax_transaction_code_id')}
            />),
          title: 'Update Destruction',
          modalSize: 'modal-xl',
        });
      case 13:
        return setModal({
          isOpen: true,
          content: (
            <EditBuildingModal
              modalType="EDIT"
              applicationId={applicationId}
              transactionCode={_.get(data, 'attributes.rptax_transaction_code_id')}
            />),
          title: 'Update Reclassification',
          modalSize: 'modal-xl',
        });
      default:
        return "";
    }
  };

  const handleActivePage = index => () => {
    setActiveTab(index);
  };

  const scrollToLeft = (e) => {
    e.preventDefault();
    const width = scrollref.current.scrollWidth;
    const slide = width / 15;
    const val = formData.scroll - slide < 0 ? 0 : formData.scroll - slide;
    scrollref.current.scrollLeft = val;
    setFormData({
      scroll: val,
      totalwidth: width,
      rightdistance:
        scrollref.current.offsetWidth + scrollref.current.scrollLeft
    });
  };

  const handleOnClickTransactionModal = (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <TransactionModal ordinanceRevisionId={+ordinanceRevisionId} />,
      title: 'Transaction',
      modalSize: 'modal-md',
      modalContentSize: 'custom-size',
    });
  };

  const scrollToRight = (e) => {
    e.preventDefault();

    const width = scrollref.current.scrollWidth;
    const slide = width / 15;
    const calculatedWidth = width - slide;
    const val =
      formData.scroll + slide > calculatedWidth
        ? calculatedWidth
        : formData.scroll + slide;
    scrollref.current.scrollLeft = val;
    setFormData({
      scroll: val,
      totalwidth: width,
      rightdistance:
        scrollref.current.offsetWidth + scrollref.current.scrollLeft
    });
  };

  const isApprovalEmpty =
    _.isEmpty(applicationInfo, 'attributes.appraised_assessed_by_id') ||
    _.isEmpty(applicationInfo, 'attributes.recommending_by_id') ||
    _.isEmpty(applicationInfo, 'attributes.approved_by_id');

  return (
    <>
      <div className="row mb-3">
        <div className="ml-auto">
          <button
            type="button"
            onClick={handleOnClickTransactionModal}
            className="btn button-transaction font-weight-bold"
            style={{ marginRight: 30 }}
          >
            Transaction
          </button>
        </div>
      </div>
      <div className="ml-3 card right-section">
        <div className="p-3">
          <div className="d-flex justify-content-between mb-3">
            <div className="col-4 mt-2">
              <h3><b>{_.get(applicationInfo, 'attributes.tdn')}</b></h3>
            </div>
            <div className="col-8 d-flex">
              <div className="ml-auto" />
              {[
                'PENDING',
                'FOR APPRAISAL AND ASSESSMENT',
                'TRANSFERRED',
                'FOR REASSESSMENT',
              ].indexOf(_.get(applicationInfo, 'attributes.status')) > -1 &&
                (
                  <div className="ml-3">
                    <button
                      type="button"
                      onClick={handleEdit(applicationInfo)}
                      className="btn btn-primary cms-bg-color-primary cms-outline-primary font-weight-bold px-4 ml-auto"
                    >
                      Edit&nbsp;
                    </button>
                  </div>
                )}
              {Acl(permissions, ['E2E RPT BUILDING APPLICATION POST']) &&
                [
                  'PENDING',
                  'FOR APPRAISAL AND ASSESSMENT',
                  'FOR REASSESSMENT',
                ].indexOf(_.get(applicationInfo, 'attributes.status')) > -1 &&
                (_.get(
                  applicationInfo,
                  'included.transactionCode.attributes.code'
                ) !== 'TR' ||
                  !isApprovalEmpty) && (
                  <div className="ml-3">
                    <button
                      type="button"
                      onClick={handlePost(applicationInfo)}
                      className="btn btn-primary cms-bg-color-primary cms-outline-primary font-weight-bold px-4 ml-auto"
                    >
                      Post&nbsp;
                    </button>
                  </div>
                )}
              {Acl(permissions, ['E2E RPT BUILDING APPLICATION REVERT']) &&
                Acl(permissions, ['E2E RPT BUILDING APPLICATION REVERT TRANSFER'])
                &&
                ['CANCELLED'].indexOf(
                  _.get(applicationInfo, 'attributes.status')
                ) > -1 && (
                  <div className="ml-3">
                    <button
                      type="button"
                      onClick={handleRevert(applicationInfo)}
                      className="btn btn-primary cms-bg-color-primary cms-outline-primary font-weight-bold px-4 ml-auto"
                    >
                      Revert&nbsp;
                    </button>
                  </div>
                )}
              {Acl(permissions, ['E2E RPT BUILDING APPLICATION UNPOST']) &&
                _.get(applicationInfo, 'attributes.status') === 'POSTED' && (
                  <div className="ml-3">
                    <button
                      type="button"
                      onClick={handleCancel(applicationInfo)}
                      className="btn btn-danger font-weight-bold px-4 ml-auto"
                    >
                      Unpost&nbsp;
                    </button>
                  </div>
                )}
            </div>
          </div>
          <div className="d-flex justify-content-between mb-3">
            <div className="col-12 d-flex">
              {Acl(permissions, ['E2E RPT BUILDING APPLICATION LOGS']) && (
                <div className="ml-auto">
                  <button
                    type="button"
                    onClick={handleLogsModal(applicationInfo)}
                    className="btn btn-primary cms-bg-color-primary cms-outline-primary font-weight-bold px-4 ml-auto"
                  >
                    Logs
                  </button>
                </div>
              )}
            </div>
          </div>
          {!_.isEmpty(applicationInfo) ? (
            <>
              <div className="page-submenu d-flex justify-content-between align-content-center">
                <button type="button" className="tab-arrow left" onClick={scrollToLeft}>
                  <div
                    style={{ cursor: 'pointer' }}
                    className={`fa fa-caret-left ${+formData.scroll === 0 ? "d-none" : ""
                      }`}
                  />
                </button>

                <ul className="tab-list tab-scroll no-border scroll" ref={scrollref}>
                  {(Acl(permissions, ['E2E RPT TREASURY']) === true && Acl(permissions, ['E2E RPT ASSESSOR']) === false) && (
                    <>
                      <li className="tab-item">
                        <button type="button" className={`btn-blank py-2 px-3 ${activeTab === 1 ? 'active' : ''}`} onClick={handleActivePage(1)}>
                          Property Location
                        </button>
                      </li>
                      <li className="tab-item">
                        <button type="button" className={`btn-blank py-2 px-3 ${activeTab === 2 ? 'active' : ''}`} onClick={handleActivePage(2)}>
                          Information
                        </button>
                      </li>
                      <li className="tab-item">
                        <button type="button" className={`btn-blank py-2 px-3 ${activeTab === 3 ? 'active' : ''}`} onClick={handleActivePage(3)}>
                          Floor Plan
                        </button>
                      </li>
                      <li className="tab-item">
                        <button type="button" className={`btn-blank py-2 px-3 ${activeTab === 4 ? 'active' : ''}`} onClick={handleActivePage(4)}>
                          Additional Items
                        </button>
                      </li>
                      {/* <li className="tab-item">
                        <button type="button" className={`btn-blank py-2 px-3 ${activeTab === 5 ? 'active' : ''}`} onClick={handleActivePage(5)}>
                          Additional Costs
                        </button>
                      </li> */}
                      <li className="tab-item">
                        <button type="button" className={`btn-blank py-2 px-3 ${activeTab === 5 ? 'active' : ''}`} onClick={handleActivePage(5)}>
                          Property Appraisal
                        </button>
                      </li>
                      <li className="tab-item">
                        <button type="button" className={`btn-blank py-2 px-3 ${activeTab === 6 ? 'active ' : ''}`} onClick={handleActivePage(6)}>
                          Property Assessment
                        </button>
                      </li>
                      <li className="tab-item">
                        <button type="button" className={`btn-blank py-2 px-3 ${activeTab === 7 ? 'active ' : ''}`} onClick={handleActivePage(7)}>
                          Structural Types
                        </button>
                      </li>
                      <li className="tab-item">
                        <button type="button" className={`btn-blank py-2 px-3 ${activeTab === 8 ? 'active' : ''}`} onClick={handleActivePage(8)}>
                          Superseded Assessment
                        </button>
                      </li>
                      <li className="tab-item">
                        <button type="button" className={`btn-blank py-2 px-3 ${activeTab === 9 ? 'active ' : ''}`} onClick={handleActivePage(9)}>
                          Transactions
                        </button>
                      </li>
                      <li className="tab-item">
                        <button type="button" className={`btn-blank py-2 px-3 ${activeTab === 10 ? 'active ' : ''}`} onClick={handleActivePage(10)}>
                          History
                        </button>
                      </li>
                      <li className="tab-item">
                        <button type="button" className={`btn-blank py-2 px-3 ${activeTab === 11 ? 'active ' : ''}`} onClick={handleActivePage(11)}>
                          Payment History
                        </button>
                      </li>
                    </>
                  )}
                  {Acl(permissions, ['E2E RPT TREASURY']) && Acl(permissions, ['E2E RPT ASSESSOR']) && (
                    <>
                      <li className="tab-item">
                        <button type="button" className={`btn-blank py-2 px-3 ${activeTab === 1 ? 'active' : ''}`} onClick={handleActivePage(1)}>
                          Property Location
                        </button>
                      </li>
                      <li className="tab-item">
                        <button type="button" className={`btn-blank py-2 px-3 ${activeTab === 2 ? 'active' : ''}`} onClick={handleActivePage(2)}>
                          Information
                        </button>
                      </li>
                      <li className="tab-item">
                        <button type="button" className={`btn-blank py-2 px-3 ${activeTab === 3 ? 'active' : ''}`} onClick={handleActivePage(3)}>
                          Floor Plan
                        </button>
                      </li>
                      <li className="tab-item">
                        <button type="button" className={`btn-blank py-2 px-3 ${activeTab === 4 ? 'active' : ''}`} onClick={handleActivePage(4)}>
                          Additional Items
                        </button>
                      </li>
                      {/* <li className="tab-item">
                        <button type="button" className={`btn-blank py-2 px-3 ${activeTab === 5 ? 'active' : ''}`} onClick={handleActivePage(5)}>
                          Additional Costs
                        </button>
                      </li> */}
                      <li className="tab-item">
                        <button type="button" className={`btn-blank py-2 px-3 ${activeTab === 5 ? 'active' : ''}`} onClick={handleActivePage(5)}>
                          Property Appraisal
                        </button>
                      </li>
                      <li className="tab-item">
                        <button type="button" className={`btn-blank py-2 px-3 ${activeTab === 6 ? 'active ' : ''}`} onClick={handleActivePage(6)}>
                          Property Assessment
                        </button>
                      </li>
                      <li className="tab-item">
                        <button type="button" className={`btn-blank py-2 px-3 ${activeTab === 7 ? 'active ' : ''}`} onClick={handleActivePage(7)}>
                          Structural Types
                        </button>
                      </li>
                      <li className="tab-item">
                        <button type="button" className={`btn-blank py-2 px-3 ${activeTab === 8 ? 'active' : ''}`} onClick={handleActivePage(8)}>
                          Superseded Assessment
                        </button>
                      </li>
                      <li className="tab-item">
                        <button type="button" className={`btn-blank py-2 px-3 ${activeTab === 9 ? 'active ' : ''}`} onClick={handleActivePage(9)}>
                          Transactions
                        </button>
                      </li>
                      <li className="tab-item">
                        <button type="button" className={`btn-blank py-2 px-3 ${activeTab === 10 ? 'active ' : ''}`} onClick={handleActivePage(10)}>
                          History
                        </button>
                      </li>
                      <li className="tab-item">
                        <button type="button" className={`btn-blank py-2 px-3 ${activeTab === 11 ? 'active ' : ''}`} onClick={handleActivePage(11)}>
                          Payment History
                        </button>
                      </li>
                    </>
                  )}
                  {(Acl(permissions, ['E2E RPT TREASURY']) === false && Acl(permissions, ['E2E RPT ASSESSOR']) === true) && (
                    <>
                      <li className="tab-item">
                        <button type="button" className={`btn-blank py-2 px-3 ${activeTab === 1 ? 'active' : ''}`} onClick={handleActivePage(1)}>
                          Property Location
                        </button>
                      </li>
                      <li className="tab-item">
                        <button type="button" className={`btn-blank py-2 px-3 ${activeTab === 2 ? 'active' : ''}`} onClick={handleActivePage(2)}>
                          Information
                        </button>
                      </li>
                      <li className="tab-item">
                        <button type="button" className={`btn-blank py-2 px-3 ${activeTab === 7 ? 'active ' : ''}`} onClick={handleActivePage(7)}>
                          Property Assessment
                        </button>
                      </li>
                    </>
                  )}
                </ul>
                <button type="button" className="tab-arrow right" onClick={scrollToRight}>
                  <div
                    style={{ cursor: 'pointer' }}
                    className={`fa fa-caret-right ${+formData.totalwidth === +formData.rightdistance
                      ? "d-none"
                      : ""
                      }`}
                  />
                </button>
              </div>
              <div className="tabs-details p-2">
                {activeTab === 1 ? <PropertyLocation applicationInfo={applicationInfo} /> : ''}
                {activeTab === 2 ? <Information applicationInfo={applicationInfo} /> : ''}
                {activeTab === 3 ? <FloorAreaContainer applicationId={applicationInfo.id} applicationInfo={applicationInfo} /> : ''}
                {activeTab === 4 ? <AdditionalItemsContainer applicationId={applicationInfo.id} applicationInfo={applicationInfo} ordinanceRevisionId={ordinanceRevisionId} /> : ''}
                {/* {activeTab === 5 ? <AdditionalCostsContainer applicationId={applicationInfo.id} /> : ''} */}
                {activeTab === 5 ? <PropertyAppraisalContainer applicationId={applicationInfo.id} applicationInfo={applicationInfo} /> : ''}
                {activeTab === 6 ? <PropertyAssessmentContainer applicationId={applicationInfo.id} applicationInfo={applicationInfo} /> : ''}
                {activeTab === 7 ? <StructuralMaterialsContainer applicationId={applicationInfo.id} applicationInfo={applicationInfo} /> : ''}
                {activeTab === 8 ? <SupersededAssessmentContainer applicationId={applicationInfo.id} applicationInfo={applicationInfo} applicationType={_.get(applicationInfo, 'attributes.rptax_transaction_code_id')} /> : ''}
                {activeTab === 9 ? <BuildingTransactionsContainer applicationId={applicationInfo.id} applicationInfo={applicationInfo} /> : ''}
                {activeTab === 10 ? <HistoryContainer applicationId={applicationInfo.id} applicationInfo={applicationInfo} /> : ''}
                {activeTab === 11 ? <PaymentHistory applicationId={applicationInfo.id} applicationInfo={applicationInfo} /> : ''}
              </div>
            </>
          ) : (
            <div className="d-flex align-items-center justify-content-center h-100">
              <div className="text-center mx-auto py-4">
                <img
                  src={emptyStateImage}
                  className="img-responsive image-wrapper mb-4 mt-3"
                  alt="Empty State"
                />
                <p className="emp-title mb-0"> No Item Found </p>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}

BuildingApplicationContent.propTypes = {
  showData: PropTypes.instanceOf(Function).isRequired,
  applicationInfo: PropTypes.instanceOf(Object).isRequired,
  applicationId: PropTypes.string.isRequired,
  permissions: PropTypes.instanceOf(Array).isRequired,
  handleLogsModal: PropTypes.instanceOf(Function).isRequired,
  handlePost: PropTypes.instanceOf(Function).isRequired,
  handleCancel: PropTypes.instanceOf(Function).isRequired,
  handleRevert: PropTypes.instanceOf(Function).isRequired,
  ordinanceRevisionId: PropTypes.number.isRequired,
};

const mapStateToProps = ({ api }, { match }) => ({
  applicationInfo: _.get(api, `${c.SHOW_DATA}.item`) || {},
  applicationId: _.get(match, 'params.applicationId') || '',
  permissions: getJson('permissions'),
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(BuildingApplicationContent);
